import React from "react"

import { useIsProductConfigurationPage } from "shared/lib/useIsProductConfigurationPage"

import { AppSidebarViewModel } from "../model/useAppSidebarViewModel"
import "../styles/_app-sidebar.scss"
import { AppSidebarDesktop } from "./AppSidebarDesktop"
import { AppSidebarMobile } from "./AppSidebarMobile"

interface AppSidebarViewProps extends AppSidebarViewModel {}

export const AppSidebarView = React.memo((props: AppSidebarViewProps) => {
  const isProductConfigurationPage = useIsProductConfigurationPage()
  if (isProductConfigurationPage) {
    return null
  }
  return (
    <>
      {/* Mobile: Offcanvas sidebar - hidden on desktop via CSS */}
      <AppSidebarMobile {...props} />

      {/* Desktop: Permanent sidebar - hidden on mobile/tablet via CSS */}
      <AppSidebarDesktop {...props} />
    </>
  )
})
